import axios from 'axios'
import DateTimeHelper from '@/mixins/DateTimeHelper'
import { mapGetters } from 'vuex'

var apiBaseUrl = null
if ( window.preReservationConfiguration ) {
    apiBaseUrl = window.preReservationConfiguration.apiEndPoint
}
else if ( window.reservationConfiguration ) {
    apiBaseUrl = window.reservationConfiguration.apiEndPoint
}
else {
    apiBaseUrl = process.env.VUE_APP_CAAG_API_BASE_URL
    console.log('No API endpoint now using VUE_APP_CAAG_API_BASE_URL '+ apiBaseUrl)
}

export default {
    mixins: [DateTimeHelper],
    data: () => ({
        loading: false,
        selectedLocation: null,
        locations: [],
        selectedCar: null,
        cars: [],
        season: null,
        availableAdditionalCharges: null,
        additionalCharges: null,
        additionalChargesPrices: null,
        paymentMethods: null,
        paymentMethodButton: null,
        confirmedReservation: null,
        transactionResult: null,
        errors: [],
        defaultLoader: {
            //container: this.$refs.loadingContainer,
            canCancel: true, // default false
            isFullPage: true,
            color: 'orange',
            loader: 'spinner',
            width: 100,
            height: 100,
            backgroundColor: '#ffffff',
            opacity: 0.5,
            zIndex: 999
        },
    }),
    computed: {
      ...mapGetters([
        'type'
      ]),
    },
    methods: {
        AdditionalChargesIdsAndQuantities: function(reservation) {
            let result = [];
            if ( !this.additionalCharges && reservation.additionalCharges ) {
                this.additionalCharges = reservation.additionalCharges;
            }

            if ( this.additionalCharges ) {
                for (let i = 0; i < this.additionalCharges.length; i++) {
                    let aac = this.getAvailableAdditionalChargeById(this.additionalCharges[i].id);
                    if ( aac ) {
                        if ( this.additionalCharges[i].mandatory ) {
                            result.push({
                                id: this.additionalCharges[i].id
                            });
                        }
                        else if ( this.additionalCharges[i].selection_type == 'only_one') {
                            if ( this.additionalCharges[i].is_selected ) {
                                result.push({
                                    id: this.additionalCharges[i].id,
                                    quantity: 1
                                });
                            }
                        }
                        else if ( this.additionalCharges[i].quantity > 0 ) {
                            result.push({
                                id: this.additionalCharges[i].id,
                                quantity: this.additionalCharges[i].quantity
                            });
                        }
                    }
                }
            }
            return result;
        },
        getLocations: function(currentLocationId) {
            const self = this;
            self.errors = [];
            const sellType = this.type;
            let loader = self.$loading.show(self.defaultLoader);
            return axios
                .get(apiBaseUrl +'/api/locations')
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.locations = response.data.fleets_locations;
                            let pickupLocation = {
                                id: -1,
                                name: "Pick up address",
                                return_allowed: false,
                                is_airport: false,
                                is_custom: true, // custom property to determine if it is a custom pickup address
                            };
                            
                            if(sellType != 'Dive') {
                                self.locations.push(pickupLocation);
                            }

                            let foundLocation = self.locations.find((location) => {
                                return location.id == currentLocationId;
                            });
                            if ( foundLocation !== undefined ) {
                                self.selectedLocation = foundLocation;
                            }
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('Geen locaties gevonden');
                    }
                    loader.hide();
                })
        },
        getReturnLocation() {
            if ( this.locations && this.locations.length > 0 ) {
                // check return locations
                let returnLocations = this.locations.filter(x => x.return_allowed);
                if ( returnLocations && returnLocations.length > 0 ) {
                    if ( returnLocations.length > 1 ) {
                        returnLocations = returnLocations.filter(x => x.is_airport == false)
                        if ( returnLocations && returnLocations.length > 0) {
                            return returnLocations[0]
                        }
                    }
                    else {
                        return returnLocations[0]
                    }
                }

                // if no return locations are found, take the first one, because this is the office
                return this.locations[0]
            }
            return null
        },     
        getCountries: function() {
            const self = this;
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/countries')
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.countries = response.data.countries;

                            let foundCountry = self.countries.find((c) => {
                                return c.code2 == self.currentCountryCode;
                            });
                            if ( foundCountry !== undefined ) {
                                self.selectedCountry = foundCountry;
                            }
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('No countries found');
                    }
                    loader.hide();
                })
        },
        getAvailableCars: function(currentCarId, fromDateTimeString, tillDateTimeString) {
            const self = this
            self.errors = [];
            self.loading = true;
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/availablecars?fromDateTime='+ fromDateTimeString +'&tillDateTime='+ tillDateTimeString)
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.cars = response.data.sort((a, b) => { return (a.vehicle_class.order - b.vehicle_class.order) });
                            if ( currentCarId ) {
                                let foundCar = self.cars.find((car) => {
                                    return car.vehicle_class.id == currentCarId;
                                });
                                if ( foundCar !== undefined ) {
                                    self.selectedCar = foundCar.vehicle_class;
                                }
                            }
                        }
                    }
                    loader.hide();
                    self.loading = false;
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('No cars found');
                    }
                    loader.hide();
                    self.loading = false;
                })
        },
        getSeasons: function (fromDateTimeString, tillDateTimeString) {
            const self = this
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/seasons')
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            let sortedSeasons = response.data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
                            // filter seasons on from/till datetime
                            var foundSeason = sortedSeasons.find((season) => {
                                if ( tillDateTimeString ) {
                                    return season.date_start <= fromDateTimeString && season.date_end >= tillDateTimeString
                                }
                                else {
                                    return season.date_start <= fromDateTimeString && season.date_end >= fromDateTimeString
                                }
                            });
                            if ( foundSeason !== undefined ) {
                                self.season = foundSeason;
                            }
                            // if we cannot find a season with tillDateTime string filled, then ignore this property and try to find a season with only the startDateTime
                            else if ( tillDateTimeString ) {
                                foundSeason = sortedSeasons.find((season) => {
                                    return season.date_start <= fromDateTimeString && season.date_end >= fromDateTimeString
                                });
                                if ( foundSeason !== undefined ) {
                                    self.season = foundSeason;
                                }
                            }
                            else {
                                self.error.push('No seasons found');
                            }
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.error.push('No seasons found');
                    }
                    loader.hide();
                })
        },
        getAvailableAdditionalCharges: function(currentCarId) {
            const self = this;
            self.errors = [];
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/additionalcharges')
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.availableAdditionalCharges = response.data.fleets_additional_charges.filter((ac) => {
                                let allowedVehicle = true;
                                if ( currentCarId ) {
                                    if ( ac.allowed_vehicle_classes ) {
                                        allowedVehicle = ac.allowed_vehicle_classes.find((v) => { return v == currentCarId })
                                    }
                                }
                                return ac.show_on_website && allowedVehicle;
                            }).slice().sort((a, b) => { return (a.order - b.order) });
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('No available additional charges found');
                    }
                    loader.hide();
                })
        },
        getAdditionalCharges: function(reservation) {
            const self = this;
            self.errors = [];
            let requestParams = '/'+ this.getDateTimeFormat(reservation.pickupDateTime)
                               +'/'+ this.getDateTimeFormat(reservation.returnDateTime)
                               +'/'+ reservation.location.id
                               +'/'+ reservation.car.id
            if ( reservation.customLocation ) {
                requestParams += '/'+ reservation.customLocation;
            }
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/additionalcharges' + requestParams)
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                           
                            self.additionalCharges = response.data.data.additional_charges.slice().sort((a, b) => { return (a.order - b.order) });

                            if(self.additionalCharges.length > 1 && self.type == "Dive"){
                                console.log(`There can only be one additionalCharge if type is dive. Soluition1 change AdditionalCharges.vue to work with multiple additionalCharges. Soluition2 remove extra additionalCharges from caagcrm.`)
                            }

                            for (let i = 0; i < self.additionalCharges.length; i++) {
                                if ( self.additionalCharges[i].selection_type == 'only_one' ) {
                                    self.additionalCharges[i].quantity = 0;
                                    if ( self.additionalCharges[i].mandatory || self.additionalCharges[i].recommended ) {
                                        self.additionalCharges[i].quantity = 1;
                                        if ( self.additionalCharges[i].recommended && !reservation.additionalCharges ) {
                                            self.additionalCharges[i].is_selected = true;
                                        }
                                    }
                                }

                                if ( reservation.additionalChargesPrices &&
                                    reservation.additionalChargesPrices.selectedAdditionalCharges ) {
                                    let sac = reservation.additionalChargesPrices.selectedAdditionalCharges
                                    for ( let j = 0; j < sac.length; j++ ) {
                                        if ( sac[j].id === self.additionalCharges[i].id ) {
                                            if ( self.additionalCharges[i].selection_type == 'only_one' ) {
                                                self.additionalCharges[i].is_selected = true;
                                            }
                                            else {
                                                self.additionalCharges[i].quantity = sac[j].selected_quantity;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('No additional charges found');
                    }
                    loader.hide();
                })
        },
        getAdditionalChargesPrices: function(reservation) {
            const self = this;
            self.errors = [];
            let loader = self.$loading.show(self.defaultLoader);
            let requestBody = {
                pickUpDateTime: this.getDateTimeFormat(this.reservation.pickupDateTime),
                pickUpLocationId: reservation.location.id,
                pickUpCustomLocation: reservation.customLocation,
                returnDateTime: this.getDateTimeFormat(this.reservation.returnDateTime),
                returnLocationId: 2,
                returnCustomLocation: 'AB Office',
                vehicleClassId: reservation.car.id,
                additionalCharges: self.AdditionalChargesIdsAndQuantities(reservation),
                couponCode: reservation.discountCode
            };
            axios
                .post(apiBaseUrl +'/api/additionalcharges', requestBody, {
                    headers: { 'Content-Type': 'application/json' },
                  })
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            if ( response.data.status_code === 200 ) {
                                self.additionalChargesPrices = response.data.data;
                                if ( reservation.additionalChargesPrices && reservation.additionalChargesPrices.selectedAdditionalCharges ) {
                                    self.additionalChargesPrices.selectedAdditionalCharges = reservation.additionalChargesPrices.selectedAdditionalCharges;
                                }
                            }
                            else if ( response.data.status_code === 410 ) {
                                self.errors.push(response.data.errors.error_message);
                            }
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('No prices for additional charges found');
                    }
                    loader.hide();
                })
        },
        confirmReservation: async function(reservation) {
            const self = this;
            self.errors = [];
            self.additionalCharges = reservation.additionalCharges;
            self.availableAdditionalCharges = reservation.availableAdditionalCharges;
            let reservationRequest = {
                pickUpDateTime: this.getDateTimeFormat(this.reservation.pickupDateTime),
                pickUpLocationId: reservation.location.id,
                pickUpCustomLocation: reservation.customLocation,
                returnDateTime: this.getDateTimeFormat(this.reservation.returnDateTime),
                returnLocationId: 2,
                returnCustomLocation: 'AB Office',
                vehicleClassId: reservation.car.id,
                additionalCharges: self.AdditionalChargesIdsAndQuantities(reservation),
                contact: reservation.contact
            };
            if ( reservation.location.is_airport ) {
                reservationRequest.flight_arrival_datetime = this.getDateTimeFormat(reservation.flight.arrivalDateTime);
                reservationRequest.flight_number = reservation.flight.flightNumber;
            }
            reservationRequest.contact.dateOfBirth = this.getDateFormat(reservationRequest.contact.dateOfBirth);
            let loader = self.$loading.show(self.defaultLoader);
            await axios
                .post(apiBaseUrl +'/api/reservation', reservationRequest)
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.confirmedReservation = response.data.data.reservation
                            self.$store.commit("setReservationId", self.confirmedReservation.id)
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('Reservation could not be confirmed!');
                    }
                    loader.hide();
                })
            return self.errors.length === 0
        },
        getPaymentMethods: function() {
            const self = this;
            self.errors = [];
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/paymentmethods')
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.paymentMethods = response.data.data;
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('Payment methods could not be found!');
                    }
                    loader.hide();
                })
        },
        getPaymentMethodButton: function(reservation, paymentMethod, buttonLabel) {
            const self = this;
            self.errors = [];
            let paymentMethodButtonRequest = {
                id: paymentMethod.id,
                returnUrl: location.origin + reservation.basePath + '/success',
                buttonLabel: buttonLabel,
                amount: reservation.additionalChargesPrices.total.outstanding_balance.amount,
                itemId: reservation.id,
                itemType: 'reservation'
            };
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .post(apiBaseUrl +'/api/paymentmethods', paymentMethodButtonRequest, {
                    headers: { 'Content-Type': 'application/json' },
                  })
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.paymentMethodButton = response.data.button;
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.errors.push('Payment method button could not be found!');
                    }
                    loader.hide();
                })
        },
        checkPaymentTransaction: function(token) {
            const self = this;
            self.errors = [];
            let loader = self.$loading.show(self.defaultLoader);
            axios
                .get(apiBaseUrl +'/api/paymenttransaction?token='+ token)
                .then(function(response) {
                    if (response.status === 200) {
                        if ( response.data ) {
                            self.transactionResult = response.data.payment_gateways_transaction
                        }
                    }
                    loader.hide();
                })
                .catch(function(error) {
                    if (error.response && error.response.status === 400) {
                        self.transactionResult = {
                            status: "notfound"
                        }
                        self.errors.push('Payment transaction could not be found!')
                    }
                    loader.hide();
                })
        },
        getAvailableAdditionalChargeById(id) {
            if ( this.availableAdditionalCharges ) {
                return this.availableAdditionalCharges.find((ac) => {
                    return ac.id == id;
                });
            }
        },
        cleanReservation() {
            this.selectedLocation = null
            this.selectedCountry = null
            this.selectedCar = null
            this.season = null
            this.availableAdditionalCharges = null
            this.additionalCharges = null
            this.additionalChargesPrices = null
        }
    }
}
